import { useEffect, useState } from 'react';
import { getIngestApiDetails } from '../../api/originatorApi';

export function ApiUploadInstructions() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [details, setDetails] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const response = await getIngestApiDetails();
        if (!cancelled) setDetails(response);
      } catch (requestError) {
        if (!cancelled) {
          setDetails(null);
          setError(requestError.message || 'Could not load API instructions.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <p className="text-[13px] text-eorig-muted">Loading API upload steps…</p>;
  }
  if (error) {
    return (
      <p className="text-[13px] text-rose-600" role="alert">
        {error}
      </p>
    );
  }
  if (!details) {
    return null;
  }

  return (
    <div className="space-y-4 rounded-xl border border-eorig-border bg-white px-4 py-3 text-[13px] text-eorig-ink">
      <p>
        Push documents from your systems using the public upload API. Base URL:{' '}
        <span className="font-mono text-[12px]">{details.base_url}</span>
      </p>
      {details.notes?.length ? (
        <ul className="list-disc space-y-1 pl-5 text-[12px] text-eorig-muted">
          {details.notes.map((note) => (
            <li key={note}>{note}</li>
          ))}
        </ul>
      ) : null}
      <ol className="space-y-3">
        {(details.steps || []).map((step) => (
          <li key={step.order}>
            <p className="font-semibold">
              {step.order}. {step.title}{' '}
              <span className="font-normal text-eorig-muted">
                ({step.method} {step.path})
              </span>
            </p>
            <p className="mt-1 text-[12px] text-eorig-muted">{step.description}</p>
            {step.curl ? (
              <pre className="mt-2 overflow-x-auto rounded-lg bg-eorig-surface p-2 font-mono text-[11px]">
                {step.curl}
              </pre>
            ) : null}
          </li>
        ))}
      </ol>
    </div>
  );
}
